export const SET_AUTH_USER = 'SET_AUTH_USER';
export const SET_AUTH_STATE = 'SET_AUTH_STATE';
